<script lang="ts">
  import { onMount } from "svelte"
  import Widget from "$lib/components/Widget2/Widget2.svelte"
  // import InstagramWarning from "@/lib/components/InAppBrowserWarning/Instagram.svelte"
  // import FacebookWarning from "$lib/components/InAppBrowserWarning/Facebook.svelte"
  // import LinkedInWarning from "$lib/components/InAppBrowserWarning/LinkedIn.svelte"
  import ChatButton from "$lib/components/WidgetVariation/ChatButton.svelte"
  import Bar from "$lib/components/WidgetVariation/Bar.svelte"
  import { setContext } from "svelte"

  let { data } = $props()

  let layout = $state("default")
  let heightUpdateTimeout: ReturnType<typeof setTimeout> | null = null

  setContext("inAppBrowser", data.inAppBrowser)

  function getFullHeight() {
    const body = document.body
    const html = document.documentElement

    // Check if we're on mobile
    const isMobile =
      window.innerWidth <= 768 || /Mobi|Android/i.test(navigator.userAgent)

    if (isMobile) {
      // On mobile, prioritize body measurements and be more conservative
      // Use the smaller of scroll height vs offset height to avoid inflated values
      const bodyHeight = Math.min(
        body.scrollHeight,
        body.offsetHeight || body.scrollHeight,
      )
      const clientHeight = html.clientHeight

      // Return the more conservative measurement, with a reasonable minimum
      const calculatedHeight = Math.max(bodyHeight, clientHeight)

      // Cap the height at a reasonable maximum for mobile (e.g., 2000px)
      return Math.min(calculatedHeight, 2000)
    } else {
      // Desktop behavior - use the original logic
      return Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight,
      )
    }
  }

  function updateParentHeight() {
    // Clear any pending timeout
    if (heightUpdateTimeout) {
      clearTimeout(heightUpdateTimeout)
    }

    // Debounce height updates to prevent rapid firing
    heightUpdateTimeout = setTimeout(() => {
      const height = getFullHeight()
      window.parent.postMessage({ type: "setHeight", height: height }, "*")
      heightUpdateTimeout = null
    }, 100)
  }

  onMount(() => {
    // Initial height update with a small delay to ensure DOM is ready
    setTimeout(updateParentHeight, 50)

    window.addEventListener("message", (event) => {
      if (event.data.type === "getHeight") {
        updateParentHeight()
      }
    })

    if (typeof ResizeObserver !== "undefined") {
      const isMobile =
        window.innerWidth <= 768 || /Mobi|Android/i.test(navigator.userAgent)

      const resizeObserver = new ResizeObserver(() => {
        // On mobile, be less aggressive with resize updates
        if (isMobile) {
          // Only update on significant changes
          setTimeout(updateParentHeight, 200)
        } else {
          updateParentHeight()
        }
      })

      resizeObserver.observe(document.body)

      return () => {
        resizeObserver.disconnect()
        if (heightUpdateTimeout) {
          clearTimeout(heightUpdateTimeout)
        }
      }
    }
  })
</script>

<!-- {#if data.inAppBrowser?.isInstagram}
  <InstagramWarning />
{:else if data.inAppBrowser?.isFacebook || data.inAppBrowser?.isMessenger}
  <FacebookWarning />
{:else if data.inAppBrowser?.isLinkedIn}
  <LinkedInWarning />
{:else  -->
{#if layout === "bubble"}
  <!-- Chat Button Component -->
  <ChatButton
    competition={data.competition}
    isCountryAllowed={data.isCountryAllowed}
    showCreateButton={data.competition?.widgetSettings?.showCreateButton}
  />
{:else if layout === "bar"}
  <!-- Chat Button Component -->
  <Bar
    competition={data.competition}
    isCountryAllowed={data.isCountryAllowed}
    showCreateButton={data.competition?.widgetSettings?.showCreateButton}
  />
{:else}
  <div class="flex justify-center items-center">
    <Widget
      competition={data.competition}
      isCountryAllowed={data.isCountryAllowed}
      showCreateButton={data.competition?.widgetSettings?.showCreateButton}
      embed
    />
  </div>
{/if}

<style>
  :global(body) {
    background: transparent !important;
  }
</style>
